
(function ($) {

  function getSearchResultsEventData() {
    var resultsInfo = $('.search-results');
    return [
      ['orig', resultsInfo.attr('data-orig')],
      ['spell', resultsInfo.attr('data-spell')],
      ['query', resultsInfo.attr('data-query')],
      ['topic', requestContext.searchScope],
      ['path', resultsInfo.attr('data-path')],
      ['page', resultsInfo.attr('data-page')],
      ['split', ''],
      ['inapp', gdhelp2.utils.inIframe()],
      ['internal', requestContext.internalRequest],
      ['plId', requestContext.plId]
    ];
  }

  function addTopResults(eventData) {
    var topResults = $('.search-results').attr('data-top-results').split(',');
    for (var j = 1, len = topResults.length; j <= len; j++) {
      var topId = topResults[j - 1];
      if (topId) {
        eventData.push([j.toString(), topId]);
      }
    }
  }

  function sendSearchResultsEvent(searchResultsHeader) {
    var eventData = getSearchResultsEventData();
    eventData.push(['count', searchResultsHeader.attr('data-serp-count')]);
    eventData.push(['plId', requestContext.plId]);
    addTopResults(eventData);
    ux.traffic.custom('notify', 'mcx.help.serp.results', eventData);
  }

  function searchResultAnchorOnClick() {
    var eventData = getSearchResultsEventData();
    eventData.push(['item', $(this).attr('data-seq')]);
    eventData.push(['url', this.href]);
    eventData.push(['plId', requestContext.plId]);
    ux.traffic.custom('notify', 'mcx.help.serp.results.article.click', eventData);
    return true;
  }

  function ready() {

    if ($('.search-results-instead').length > 0) {
      if (ux.traffic && ux.traffic.impression) {
        ux.traffic.impression('mcx.help.serp.spelling.correction.impression');
      }
    }

    var searchResultsHeader = $('.search-results-header');
    if (searchResultsHeader.length > 0) {
      sendSearchResultsEvent(searchResultsHeader);
    }

    $('.search-result-link a').on('click', searchResultAnchorOnClick);
  }

  $(document).ready(ready);

}(jQuery));
